<template>
  <UserDirectory directory="authors" />
</template>
